import {
  useQuery,
} from "@tanstack/react-query";

import { apiClient } from "@/api/api.ts";
import { AuthStore } from "@/store/useAuthStore.ts";
import { TPhaseISchema } from "@/models/PhaseI.schema.ts";

export const registeringAnimal = async (data: any) => {
  try {
    await apiClient.post("/animalRegistration", data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateAnimal = async (data: any) => {
  try {
    await apiClient.patch("/admin/updateAnimal", data);
  } catch (error) {
    console.error(`Error updating animal: ${error}`);
    throw error;
  }
};

export const RegisterAnimal = async (data: any) => {
  const response = await apiClient.post("/animalRegistration", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: false,
  });

  return response.data;
};

export const RegisterFarm = async (data: any) => {
  const response = await apiClient.post("/farmRegistration", data);
  return response.data;
};

export const registerFarm = RegisterFarm;


export const GetFarmerAnimals = async (id: string) => {
  // This endpoint must reflect edits made by an admin in another session.
  // Bypass browser/service-worker/proxy caches for the farmer dashboard read.
  const response = await apiClient.get(`/animals/farmer/${id}`, {
    params: { _fresh: Date.now() },
    timeout: 20_000,
  });
  return response;
};

export const getPhenotypes = async () => {
  const response = await apiClient.get("/admin/phenotype", {
    withCredentials: false,
  });

  return response.data;
};

export const GetAllAnimals = async () => {
  const response = await apiClient.get("/getAllAnimals", {
    withCredentials: false,
  });

  return response.data;
};

export const GetSomeSilaAnimals = async () => {
  const response = await apiClient.get("/getAllAnimals", {
    withCredentials: false,
  });

  return response.data;
};

export const useGetAllAnimals = () => {
  return useQuery({
    queryKey: ["animals"],
    queryFn: async () => {
      const response = await GetAllAnimals();

      return response.data;
    },
  });
};

export const useGetFarmerAnimals = () => {
  const { userInfo } = AuthStore();
  const id = userInfo.id;

  return useQuery({
    queryKey: ["animals", id],
    enabled: Boolean(id),
    queryFn: async () => {
      if (!id) throw new Error("User ID is not available");
      const response = await GetFarmerAnimals(id);
      if (!Array.isArray(response.data)) {
        throw new Error("The animals API returned an invalid response");
      }
      return response.data;
    },
    networkMode: "online",
    retry: 1,
    staleTime: 0,
    refetchOnMount: "always",
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};

export const PhaseI = async (data: TPhaseISchema) => {
  const response = await apiClient
    .post("/animalRegistration", data, {
      withCredentials: false,
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });

  return response.data;
};

export const getFarmerStats = async (id: string | null) => {
  try {
    const res = await apiClient.get(`/farmerStats/${id}`);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const useGetFarmerStats = () => {
  const { userInfo } = AuthStore();

  const id = userInfo.id;

  return useQuery({
    queryKey: ["stats", id],
    queryFn: async () => {
      if (!id) {
        throw new Error("User ID is not available"); // or
        // return
        // a
        // default
        // value,
        // or...
      }
      try {
        const response = await getFarmerStats(id);

        if (response.status === 200) {
          return response.data;
        } else {
          throw new Error("Network request failed");
        }
      } catch (error) {
        console.log(error);
      }
    },
  });
};

export const useGetSilaAnimal = (id: string | undefined) => {
  return useQuery({
    queryKey: ["SilaAnimal", id],
    queryFn: async () => {
      if (!id) {
        throw new Error("Animal ID is not available"); // or
      }
      const response = await apiClient.get(`/animals/get-animal/${id}`, {
        withCredentials: false,
      });
      return response.data;
    },
  });
};
export const useGetAnimal = (animalId: string | undefined) => {
  return useQuery({
    queryKey: ["SilaAnimal", animalId],
    staleTime: 0,
    refetchOnMount: "always",
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    queryFn: async () => {
      if (!animalId) {
        throw new Error("Animal ID is not available"); // or
      }
      const response = await apiClient.get(
        `/farmers/farmer/animals/animal/get-animal/${animalId}`,
        {
          withCredentials: false,
        },
      );
      return response.data;
    },
  });
};
